import React, { useState } from "react";
import AnimatedSection from "./AnimatedSection";

export default function Services() {
  const [activeTab, setActiveTab] = useState("streaming");

  const tabs = [
    { id: "streaming", label: "Streaming Features" },
    { id: "social", label: "Social Features" },
    { id: "monetization", label: "Monetization" },
    { id: "management", label: "Management Tools" },
  ];

  const services = {
    streaming: [
      { title: "Live Streaming", desc: "Stream in high-definition, interact with your audience in real time through instant chat, and create an immersive experience with effects and on-screen overlays." },
      { title: "Multi‑Video Stream", desc: "Host up to four video feeds simultaneously, allowing for multiple camera angles, guest co-hosts, or collaborative content in one dynamic session." },
      { title: "In‑Stream Games", desc: "Boost viewer engagement by playing interactive games live. Let fans participate directly and reward them with in-game prizes and badges." },
      { title: "Private & Public Rooms", desc: "Create dedicated spaces for intimate fan interactions or open up public rooms to reach new audiences across the globe." },
    ],
    social: [
      { title: "Post & Share", desc: "Share updates like on Facebook with images, videos, likes, and comments." },
      { title: "Followers & Following", desc: "Grow your fan base and stay connected with your community." },
      { title: "Coupling System", desc: "Pair up with other streamers for collabs and shared audiences." },
      { title: "Community Interaction", desc: "Engage directly through polls, comments, and fan chats." },
    ],
    monetization: [
      { title: "Gifting & Diamonds", desc: "Earn diamonds from gifts and convert them into real income." },
      { title: "Diamond Sellers", desc: "Authorized sellers for safe and easy diamond purchases." },
      { title: "Premium Rooms", desc: "Charge entry for special rooms with exclusive content." },
      { title: "Reward System", desc: "Unlock achievements and earn bonuses through streaming milestones." },
    ],
    management: [
      { title: "Agency System", desc: "Join or create agencies to build your brand and manage talents." },
      { title: "Agent Management", desc: "Agents help manage streamers, events, and promotions." },
      { title: "Analytics Dashboard", desc: "Track your growth, earnings, and audience engagement." },
      { title: "Event Hosting", desc: "Organize and promote special live events on the platform." },
    ],
  };

  return (
    <section className="px-4 py-24 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl rounded-[2rem] border border-white/10 bg-slate-950/50 p-8 shadow-[0_30px_80px_rgba(0,0,0,0.25)] backdrop-blur-xl lg:p-12">
        <AnimatedSection className="mb-10 flex flex-col gap-4 text-center lg:text-left" delay={0.08}>
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-orange-300">Services</p>
          <h2 className="text-3xl font-semibold text-white sm:text-4xl">Everything your audience needs, wrapped in one premium platform.</h2>
          <p className="mx-auto max-w-2xl text-base leading-8 text-slate-400 lg:mx-0">From live streaming to community management, every feature is built to feel effortless, rewarding, and beautifully immersive.</p>
        </AnimatedSection>

        <AnimatedSection className="mb-8 flex flex-wrap justify-center gap-3 lg:justify-start" delay={0.12}>
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`rounded-full border px-4 py-2 text-sm font-medium transition ${activeTab === tab.id ? "border-orange-400/50 bg-orange-500/15 text-white" : "border-white/10 bg-white/5 text-slate-300 hover:border-orange-300/50 hover:text-orange-200"}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </AnimatedSection>

        <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-4">
          {services[activeTab].map((service, idx) => (
            <AnimatedSection key={service.title} className="rounded-[1.5rem] border border-white/10 bg-gradient-to-br from-white/10 to-white/5 p-6 shadow-lg shadow-black/20" delay={0.03 * idx}>
              <div className="mb-4 h-10 w-10 rounded-2xl bg-gradient-to-br from-orange-500 to-fuchsia-600" />
              <h3 className="mb-3 text-xl font-semibold text-white">{service.title}</h3>
              <p className="text-sm leading-7 text-slate-400">{service.desc}</p>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}
